import { Features } from 'generated/featureDefinitions'

import integrationCodes from 'modules/marketplace/lib/integrationCodes'

export interface UpsellableIntegration {
  id: Features
}

// Once we have more integrations that require upsell, we will add logic to the backend
export const upsellableIntegrations: Record<string, UpsellableIntegration> = {
  [integrationCodes.oracle_netsuite_bit_technologies]: {
    id: Features.marketplace_oracle_netsuite_integration,
  },
  [integrationCodes.business_central_acicatech]: {
    id: Features.marketplace_business_central_integration,
  },
  [integrationCodes.sage_200_gmintegra]: {
    id: Features.marketplace_sage200_gmintegra_integration,
  },
  [integrationCodes.datev_lauds_factorial]: {
    id: Features.marketplace_datev_factorial_integration,
  },
  [integrationCodes.milena_illusion]: {
    id: Features.marketplace_milena_illusion_integration,
  },
  [integrationCodes.suprema_xiptic]: {
    id: Features.marketplace_suprema_xiptic_integration,
  },
  [integrationCodes.a3innuva]: {
    id: Features.marketplace_a3innuva_integration,
  },
  [integrationCodes.silae_fortify]: {
    id: Features.marketplace_silae_fortify_integration,
  },
  [integrationCodes.zkteco_zkteco]: {
    id: Features.marketplace_zkteco_zkteco_integration,
  },
}
